(function() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shouldSkipAnimation(heroCaption) {
    if (!heroCaption) return true;
    const ignoreReducedMotion = heroCaption.getAttribute('data-ignore-reduced-motion') === 'true';
    if (ignoreReducedMotion) return false;
    return prefersReducedMotion;
  }

  function initHeroAnimation() {
    const heroCaption = document.querySelector('.hero-caption-animated');
    if (!heroCaption || shouldSkipAnimation(heroCaption)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('hero-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(heroCaption);
    heroCaption._heroObserver = observer;
  }

  function resetHeroAnimation() {
    const heroCaption = document.querySelector('.hero-caption-animated');
    if (!heroCaption || shouldSkipAnimation(heroCaption)) return;

    heroCaption.classList.remove('hero-animate');
    if (heroCaption._heroObserver) {
      heroCaption._heroObserver.disconnect();
    }
    requestAnimationFrame(() => initHeroAnimation());
  }

  function handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      const heroCaption = document.querySelector('.hero-caption-animated');
      if (heroCaption && !heroCaption.classList.contains('hero-animate')) {
        initHeroAnimation();
      }
    }
  }

  function handleSectionEvents() {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.hero-caption-animated')) {
        resetHeroAnimation();
      }
    });

    document.addEventListener('shopify:section:reorder', () => resetHeroAnimation());

    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.querySelector('.hero-caption-animated')) {
        resetHeroAnimation();
      }
    });
  }

  function init() {
    document.documentElement.classList.add('js');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initHeroAnimation();
        handleSectionEvents();
        window.addEventListener('popstate', () => setTimeout(resetHeroAnimation, 100));
      });
    } else {
      initHeroAnimation();
      handleSectionEvents();
      window.addEventListener('popstate', () => setTimeout(resetHeroAnimation, 100));
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
  }

  init();
})();
